import { ExtensionState, usePhoneStore } from '@hit/react-jssip';
import { useEffect } from 'react';

import { useHasQueueMetrics } from '@/api/use-branch-features';
import { useQueueLogin } from '@/api/use-queue-login';
import { useExtension } from '@/hooks/use-extension';
import { openWidget } from '@/utils/open-widget';

export function useLogin() {
  const extension = useExtension();
  const hasQueueMetrics = useHasQueueMetrics();
  const extensionState = usePhoneStore((state) => state.extensionState);
  const {
    mutate: login,
    reset: resetLoginMutation,
    isSuccess: isLoggedOnQueue,
  } = useQueueLogin();

  useEffect(() => {
    if (
      hasQueueMetrics !== true ||
      !extension ||
      extensionState !== ExtensionState.Registered
    ) {
      return;
    }

    login(extension.number);
    return resetLoginMutation;
  }, [hasQueueMetrics, extension, extensionState, login, resetLoginMutation]);

  useEffect(() => {
    if (
      (hasQueueMetrics === true && isLoggedOnQueue) ||
      (hasQueueMetrics === false &&
        extensionState === ExtensionState.Registered)
    ) {
      openWidget();
    }
  }, [hasQueueMetrics, isLoggedOnQueue, extensionState]);

  return { isLoggedOnQueue };
}
